import { render, staticRenderFns } from "./ad-campaign.vue?vue&type=template&id=5d2d42cb&scoped=true&"
import script from "./ad-campaign.vue?vue&type=script&lang=js&"
export * from "./ad-campaign.vue?vue&type=script&lang=js&"
import style0 from "./ad-campaign.vue?vue&type=style&index=0&id=5d2d42cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d42cb",
  null
  
)

export default component.exports